module.exports = __webpack_public_path__ + "static/img/H1.1b0a15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/H1.png
// module id = g14I
// module chunks = 0